import Lenis from "lenis";
import { cartStore } from "@gob/cart-store";

export function initLenis() {
  const lenis = new Lenis({
    infinite: false,
    autoRaf: true,
    autoToggle: true,
    lerp: 0.15,
    anchors: true
  });
}

(() => {
  initLenis();
  cartStore.loadCart();
})();